// Recoil
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
  useResetRecoilState,
} from "recoil";
import {
  isMenuView,
  activeTable,
  tableOrderList,
  popupState,
} from "../../atom/pos";

type PropsTypes = {
  table: number;
};

function PosHeader(props: PropsTypes) {
  // 포스 헤더

  // Recoil State
  const [isMenu, setIsMenu] = useRecoilState(isMenuView);
  const tables = useRecoilValue(tableOrderList);
  const tableNum = useRecoilValue(activeTable);
  const setPopupState = useSetRecoilState(popupState);
  const resetTable = useResetRecoilState(activeTable);

  // Function
  const countActiveTable = () => {
    let amt = 0 as number;
    tables.reduce((acc, cur) => {
      if (cur.time) {
        amt = acc + 1;
      }
      return amt;
    }, amt);
    return amt;
  };

  return (
    <>
      <div className="header-wrap">
        <div className="logo-warp">
          <div className="logo-cover">
            <img src={"/assets/images/pos/logo_vdpos.png"} alt="logo" />
          </div>
          <div className="vd">Powered by 브이디크럭스</div>
        </div>
        {props.table > 0 ? (
          <div className="pos-info-warp">
            <div className="table-num-wrap">
              <span>테이블명</span>
              <span style={{ color: "#C7CFE8" }}>
                {tableNum < 10 ? "0" + tableNum : tableNum}
              </span>
            </div>
            <div className="table-cus-wrap">
              <span>고객번호</span>
              <span className="roboto" style={{ color: "#C7CFE8" }}>
                010-1234-5678
              </span>
            </div>
          </div>
        ) : (
          <div className="pos-info-warp">
            <div className="col-wrap">
              <div className="flex row" style={{ height: 24 }}>
                <div className="title" style={{ minWidth: "72px" }}>
                  영업일시
                </div>
                <div className="content">
                  {`${
                    new Date().getMonth() + 1 < 10
                      ? "0" + (new Date().getMonth() + 1)
                      : new Date().getMonth() + 1
                  }-${
                    new Date().getDate() < 10
                      ? "0" + new Date().getDate()
                      : new Date().getDate()
                  }`}
                  (
                  {`${
                    new Date().getDay() === 0
                      ? "일"
                      : new Date().getDay() === 1
                      ? "월"
                      : new Date().getDay() === 2
                      ? "화"
                      : new Date().getDay() === 3
                      ? "수"
                      : new Date().getDay() === 4
                      ? "목"
                      : new Date().getDay() === 5
                      ? "금"
                      : "토"
                  }`}
                  )
                  {`${
                    new Date().getHours() < 10
                      ? "0" + new Date().getHours()
                      : new Date().getHours()
                  }:${
                    new Date().getMinutes() < 10
                      ? "0" + new Date().getMinutes()
                      : new Date().getMinutes()
                  }:${
                    new Date().getSeconds() < 10
                      ? "0" + new Date().getSeconds()
                      : new Date().getSeconds()
                  }`}
                </div>
              </div>
              <div className="flex row" style={{ height: 24 }}>
                <div className="title" style={{ minWidth: "72px" }}>
                  매장명
                </div>
                <div className="content">1992 덮밥&짜글이</div>
              </div>
            </div>
            <div className="col-wrap">
              <div className="flex row" style={{ height: 24 }}>
                <div className="title" style={{ minWidth: "104px" }}>
                  포스번호
                </div>
                <div className="content">01</div>
              </div>
              <div className="flex row" style={{ height: 24 }}>
                <div className="title" style={{ minWidth: "104px" }}>
                  미계산테이블
                </div>
                <div className="content">{countActiveTable()}/12</div>
              </div>
            </div>
          </div>
        )}
        {props.table > 0 ? (
          <div className="pos-menu-warp">
            <div className="menu" style={{ borderLeftWidth: "4px" }}>
              <span>프린터</span>
              <img
                className="icon"
                src={"/assets/images/pos/print.svg"}
                alt="print"
              />
            </div>
            <div
              className="menu pointer"
              onClick={() => {
                setIsMenu(!isMenu);
              }}
            >
              <img
                className="icon full-icon"
                src={"/assets/images/pos/menu.svg"}
                alt="menu"
              />
            </div>
            <div
              className="menu pointer"
              onClick={() => {
                resetTable();
              }}
            >
              <img
                className="icon full-icon"
                src={"/assets/images/pos/back2.svg"}
                alt="back"
              />
            </div>
          </div>
        ) : (
          <div className="pos-menu-warp">
            <div className="menu">
              <span>고객요청</span>
              <img
                className="icon"
                src={"/assets/images/pos/bell.svg"}
                alt="reauest"
              />
            </div>
            <div
              className="menu pointer"
              onClick={() => {
                setPopupState("res");
              }}
            >
              <span>예약</span>
              <img
                className="icon"
                src={"/assets/images/pos/res.svg"}
                alt="reserve"
              />
            </div>
            <div
              className="menu pointer"
              onClick={() => {
                setIsMenu(!isMenu);
              }}
            >
              <img
                className="icon full-icon"
                src={"/assets/images/pos/menu.svg"}
                alt="menu"
              />
            </div>
            <div
              className="menu pointer"
              onClick={() => {
                setIsMenu(false);
              }}
            >
              <img
                className="icon full-icon"
                src={"/assets/images/pos/close.svg"}
                alt="close"
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PosHeader;
